import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const User = {
//   template: `
//     <div class="user">
//       <router-view></router-view>
//     </div>
//   `
// }
const router = new Router({
  mode: "history", 
  routes: [
    {
      path: '/:co_id',
      name: 'app',
      // component: User,
      component: () => import('@/pages/index'),
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('@/pages/dashboard/index4')
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('@/pages/login')
        },
        {
          path: 'review',
          name: 'review',
          component: () => import('@/pages/review')
        },
        {
          path: 'summary',
          name: 'summary',
          component: () => import('@/pages/summary/summary')
        },
        {
          path: 'OperateLog',
          name: 'OperateLog',
          component: () => import('@/pages/summary/OperateLog')
        },
        {
          path: 'paper',
          name: 'paper',
          component: () => import('@/pages/paper/paper')
        },
        {
          path: 'rechecking',
          name: 'rechecking',
          component: () => import('@/pages/rechecking/rechecking')
        },
        {
          path: 'paper/operate',
          name: 'paperOperate',
          component: () => import('@/pages/paper/paperOperate')
        },
        {
          path: 'paper/certificate',
          name: 'certificate',
          component: () => import('@/pages/paper/certificate')
        },
        {
          path: 'paper/cochair',
          name: 'paperCochair',
          component: () => import('@/pages/paper/paperCochair')
        },
        {
          path: 'paper/edit',
          name: 'paperEdit',
          component: () => import('@/pages/paper/paperEdit')
        },
        {
          path: 'paper/end',
          name: 'paperWhite',
          component: () => import('@/pages/paper/paperWhite')
        },
        {
          path: 'paper/detail',
          name: 'paperDetail',
          component: () => import('@/pages/paper/paperDetail')
        },
        {
          path: 'paper/set',
          name: 'paperSet',
          component: () => import('@/pages/paper/paperSet')
        },
        {
          path: 'paramconfig', //参数配置 
          name: 'paramconfig',
          component: () => import('@/pages/system/paramconfig/paramconfig.vue')
        },
        {
          path: 'topic',
          name: 'topic',
          component: () => import('@/pages/system/topic')
        },
        {
          path: 'cochair',
          name: 'cochair',
          component: () => import('@/pages/system/cochair')
        },
        {
          path: 'session',
          name: 'session',
          component: () => import('@/pages/session/session')
        },
        {
          path: 'session/paper',
          name: 'sessionPaper',
          component: () => import('@/pages/session/sessionPaper')
        },
        {
          path: 'user',
          name: 'user',
          component: () => import('@/pages/user/user')
        },
        {
          path: 'invitation',
          name: 'invitation',
          component: () => import('@/pages/system/invitationInfo')
        },
        {
          path: 'invitationT',
          name: 'invitationT',
          component: () => import('@/pages/system/invitationInfoT')
        },
        {
          path: 'invitationInfo',
          name: 'invitationInfo',
          component: () => import('@/pages/other/invitation')
        },
        {
          path: 'invitationTemplate',
          name: 'invitationTemplate',
          component: () => import('@/pages/other/invitationEdit')
        },
        {
          path: 'email',
          name: 'email',
          component: () => import('@/pages/email/email')
        },
        {
          path: 'email/send',
          name: 'emailSend',
          component: () => import('@/pages/email/emailSend')
        },
        {
          path: 'email/detail',
          name: 'emailDetail',
          component: () => import('@/pages/email/emailDetail')
        },
        {
          path: 'email/template',
          name: 'emailTemplate',
          component: () => import('@/pages/email/emailTemplate')
        },
        {
          path: 'email/revieweremail',
          name: 'reviewerEmail',
          component: () => import('@/pages/email/revieweremail')
        },
        {
          path: 'invitation',
          name: 'invitation',
          component: () => import('@/pages/other/invitation')
        },
        {
          path: 'reviewerInvite',
          name: 'reviewerInvite',
          component: () => import('@/pages/invitationJudges/list')
        }
      ]
    },
    // 评审邀请页面
    {
      path: '/:co_id/reviewer',
      name: 'reviewer',
      component: () => import('@/pages/invitationJudges/index')
    },
    {
      path: '/:co_id/papercopyright',
      name: 'papercopyright',
      component: () => import('@/pages/invitationJudges/papercopyright')
    }

  ]
})

router.beforeEach((to, from, next) => {
  console.log('to',to)
  console.log('from',from)
   // check if the route has a hash symbol (#)
  if (to.fullPath.includes('/#')) {
    // replace the # with an empty string
    const pathWithoutHash = to.fullPath.replace('/#', '')
    // redirect to the new path
    next({ path: pathWithoutHash, query: to.query })
  } else {
    // proceed to the next route
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js